module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flower-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "dots-container",
    style: (_vm.dotsContainerStyle)
  }, [_c('div', {
    staticClass: "big-dot",
    style: (_vm.biggerDotStyle)
  }, [_c('div', {
    staticClass: "small-dot",
    style: (_vm.smallerDotStyle)
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b983254", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b983254"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/FlowerSpinner.vue
// module id = 844
// module chunks = 0